import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { faTrashAlt, faEdit, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons'

const UbicacionesAdmin = ({ baseUrl, Titulo }) => {

	//almacena toda la data de categorias 
	const [data, setData] = useState([
		{
			check: false,
			nombre: ''
		}
	])
	//almacena el campo Nombre de categoria
	const [nombre, setNombre] = useState('')
	//almacena el campo Nombre de categoria
	const [padre, setPadre] = useState('')
	//almacena el campo Nombre de categoria
	const tiposEstados = ['contado', 'credito', 'cancelado']
	//almacena el campo Nombre de categoria
	const [tipo, setTipo] = useState('')
	//almacena la categoria seleccionada
	const [categoriaSelect, setCategoriaSelect] = useState({})
	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('cargando')
	//Alerta del error para la validacion de formulario
	const [alerta, setAlerta] = useState(false)

	const [buscar, setBuscar] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	//array listo para enviar a eliminar
	const [idSelect, setIdSelect] = useState([])
	//todos los checks activos o no
	const [checkActivos, setCheckActivos] = useState(false)

	//revisa si si está el registro y mira si el check esta activo o no
	const SiesActivo = dato => {
		let resp = true
		data.map((item) => {
			if (dato === item.id && item.check === false) {
				resp = false
			}
		})
		return resp
	}

	//actualiza el check agregando true o false al array
	const actualizarCheck = (newData, ids, chec) => {
		data.map((item) => {
			if (item.id === ids) {
				newData.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: chec ? true : false
				})
			} else { newData.push(item) }
		})
		return newData
	}

	//Selecciona varios elementos y agrega en array listo para enviar a eliminar
	const SeleccionarVarios = ids => e => {
		if (SiesActivo(ids)) {
			console.log(SiesActivo(ids))
			let newArr = []
			actualizarCheck(newArr, ids, false)
			setData(newArr)

		} else {
			console.log(SiesActivo(ids))
			let newArr = []
			actualizarCheck(newArr, ids, true)
			setData(newArr)
			//console.log('si esta y es no esta activa')
		}
	}

	const SeleccionarTodo = (e) => {

		let newArr = []
		if (checkActivos) {
			data.map((item) => {
				newArr.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: false
				})
			})
			setCheckActivos(false)
		} else {
			data.map((item) => {
				newArr.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: true
				})
			})
			setCheckActivos(true)
		}

		console.log(newArr)
		setData(newArr)
	}


	//actualiza el registro de la categoria seleccionada
	const actualizarDato = (dato, name) => {
		setCategoriaSelect({ ...categoriaSelect, [name]: dato })
	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatos = async () => {
		await axios.get(baseUrl)
			.then(response => {
				let respuesta = response.data
				let newArr = []
				respuesta.map((item) => {
					newArr.push({
						...item,
						check: false
					})
				})
				setData(newArr)
				setFuncion('ver')
			})
	}



	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete = async () => {
		let array = []

		//selecciona en un array nuevo los que están seleccionados por el check
		data.map((item) => {
			if (item.check == true) {
				array.push(item.id)
			}
		})

		console.log(array.toString())
		let f = new FormData();
		f.append("METHOD", "DELETE");
		await axios.post(baseUrl, f, { params: { id: array.toString() } })
			.then(response => {
				//devuelve lo que eliminó
				let respuesta = response.data.split(',')

				//llena los registros que no estan en el response y que fueron eliminados
				let arr = []
				data.map((item) => {
					if (!estaOno(respuesta, item.id)) {
						arr.push(item)
					}
				})
				console.log(arr)
				setData(arr)
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})
	}

	//pregunta si esta o no en comparacion al response y devuelve bool
	const estaOno = (array, id) => {
		let res = false
		array.map((val) => {
			if (id == val) {
				res = true
			}
		})
		return res
	}


	//Selecciona categoria para editarla o borrarla 
	const SeleccionarCategoria = (funcion) => e => {
		setFuncion(funcion)
		if (funcion === 'editar') {
			setFuncion('editar')
		}
	}

	//Consulta para editar campos
	const peticionPut = async () => {
		if (categoriaSelect.nombre !== '' && categoriaSelect.tipo !== '') {
			let f = new FormData()
			f.append("nombre", categoriaSelect.nombre)
			f.append("padre", categoriaSelect.padre)
			f.append("METHOD", "PUT")
			await axios.post(baseUrl, f, { params: { id: categoriaSelect.id } })
				.then(response => {
					let dataNueva = data
					dataNueva.map(item => {
						if (item.id === categoriaSelect.id) {
							item.nombre = categoriaSelect.nombre
							item.padre = categoriaSelect.padre
						}
					})
					setData(dataNueva)
					setFuncion('ver')
					setAlerta(false)
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {
		if (nombre !== '') {
			let f = new FormData()
			f.append('nombre', nombre)
			f.append('padre', padre !== '' ? padre : ' ')
			f.append('METHOD', 'POST')
			await axios.post(baseUrl, f)

				.then(response => {

					let respuesta = data.concat(response.data);
					//Obtiene el ultimo dato del response para luego extraer array:
					let ultimo = respuesta[respuesta.length - 1];
					//obtiene el ultimo id para luego restarlo
					let ultimoId = ultimo.id;
					//obtiene el padre
					let ultimoPadre = ultimo.padre;
					//General el array con cada nombre o ubicación
					let array = ultimo.nombre.split("\n");
					//Borra el ultimo registro del response para luego sumar el nuevo array
					respuesta = respuesta.slice(0, -1);

					//crea nuevo array con los datos del array ultimo
					let newArr = [];
					//resta el tamaño del array con la cantidad de ids
					let contInicio = ultimoId - array.length;
					array.map((item) => {
						contInicio++;
						newArr.push({
							id: contInicio.toString(),
							nombre: item,
							padre: ultimoPadre,
							check: false
						})
					})
					//Suma los arrays para hacer el resultado final
					setData([
						...respuesta,
						...newArr,
					])

					//setData(data.concat(response.data));
					setNombre('')
					setAlerta('')
					setFuncion('ver')
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Trae todas las categorias de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])


	return (
		<div>
			<div className="row">
				<div className="col-md-5">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-7">
					<div className="filtroPedidos">
						<button
							onClick={e => setFuncion('crear')}
							className="btn boton_estandar btn-lg derecha">
							<FontAwesomeIcon icon={faPlus} />
						</button>
					</div>
					<div className="filtroPedidos">
						<button
							onClick={SeleccionarCategoria('eliminar')}
							className="btn boton_estandar_blanco btn-lg derecha">
							<FontAwesomeIcon icon={faTrashAlt} />
						</button>
					</div>
					<div className="filtroPedidos">
						<button
							onClick={e => setBuscar(!buscar)}
							className="btn boton_estandar_blanco btn-lg derecha">
							<FontAwesomeIcon icon={faSearch} />
						</button>
					</div>
					{buscar ?
						<div className="filtroPedidos">
							<MDBInput
								className="btnBuscar"
								name="busqueda"
								value={busqueda}
								onChange={e => setBusqueda(e.target.value)}
								placeHolder="Buscar"
								outline
							/>
						</div>
						: null}
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">

					{funcion === 'editar' ?
						<div>
							<h4>Actualizar Estado</h4>
							<hr />

							<MDBInput
								label="Nombre Ubicación"
								onChange={e => actualizarDato(e.target.value, e.target.name)}
								name="nombre"
								value={categoriaSelect && categoriaSelect.nombre}
								outline />

							<div>
								<select
									className="browser-default custom-select selectAtri"
									name="padre"
									value={categoriaSelect && categoriaSelect.padre}
									onChange={e => actualizarDato(e.target.value, e.target.name)}
								>
									<option value="">Selecciona Categoría</option>
									{data.map((item, index) => {
										return (
											<option key={index} value={item.nombre}>{item.nombre}</option>
										)
									})}
								</select>
							</div>
							<br />

							{alerta ? <p className="error">¡Llena todos los campos!</p> : <span></span>}

							<div className="col text-center">
								<button
									onClick={peticionPut}
									className="btn boton_estandar"
								>Actualizar Ubicación
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>
							</div>
						</div>
						: null}

					{funcion === 'crear' ?

						<div>
							<h4>Subir Ubicación:</h4>
							<hr />

							<MDBInput
								type="textarea"
								name="nombre"
								value={nombre}
								onChange={e => setNombre(e.target.value)}
								label="Ubicaciones:"
								rows="9"
								outline
							/>


							<div>
								<select
									className="browser-default custom-select selectAtri"
									name="padre"
									value={padre}
									onChange={e => setPadre(e.target.value)}
								>
									<option value="">Selecciona Categoría</option>
									{data.map((item, index) => {
										return (
											<option key={index} value={item.nombre}>{item.nombre}</option>
										)
									})}
								</select>
							</div>
							<br></br>

							<br></br>

							{alerta ? <p className="error">¡Llena todos los campos!</p> : <span></span>}

							<div className="col text-center">

								<button
									onClick={peticionPost}
									className="btn boton_estandar"
								>Subir Ubicación
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>

							</div>
						</div>
						: null}

					{funcion === 'eliminar' ?

						<div>
							<h4>¿Desea Realmente Eliminar?</h4>
							<hr />
							<div className="col text-center">

								<p>Categoria: {categoriaSelect.nombre}</p>
								<button
									onClick={peticionDelete}
									className="btn boton_estandar"
								>Eliminar
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>

							</div>
						</div>
						: null}

					{funcion === 'cargando' ?
						<div className="loader">Loading...</div>
						: null}

					{funcion === 'ver' ?

						<div>
							<MDBTable hover responsive>
								<MDBTableHead>
									<tr>
										<th>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input
													type="checkbox"
													checked={checkActivos}
													onClick={SeleccionarTodo}
													className="custom-control-input"
													style={{ marginBottom: "10px" }}
													id="todo"
												/>
												<label className="custom-control-label" for="todo"></label>
											</div>
										</th>
										<th>Id</th>
										<th>Nombre</th>
										<th>Categoría</th>
										<th></th>
									</tr>
								</MDBTableHead>
								<MDBTableBody>

									{data.filter((item) => {
										if (busqueda == "") {
											return item.nombre
										} else if (item.nombre.toLowerCase().includes(busqueda.toLowerCase())) {
											return item.nombre
										}

									}).map((item, index) => {
										return (
											<tr key={index}>
												<td style={{ width: '20px' }}>
													<div className="custom-control custom-checkbox custom-control-inline">
														<input
															type="checkbox"
															checked={item.check}
															onClick={SeleccionarVarios(item.id)}
															id={item.id} className="custom-control-input"
														/>

														<label className="custom-control-label" for={item.id}></label>
													</div>
												</td>
												<td>{item.id}</td>
												<td>{item.nombre}</td>
												<td>{item.padre}</td>
												<td className="tabla_funciones">
													<div className="col text-center">
														<button
															onClick={SeleccionarCategoria(item, 'editar')}
															className="btn boton_estandar_blanco"
														><FontAwesomeIcon icon={faEdit} size="lg" />
														</button>
													</div>

												</td>
											</tr>
										)
									})}

								</MDBTableBody>
							</MDBTable>
						</div>

						: null}
				</div>
			</div>
		</div>
	)
}

export default UbicacionesAdmin